import { useEffect, useMemo, useState } from "react"
import { useEffectiveUserSnapshot } from "./useEffectiveUserSnapshot"
import { UserType } from "../../../../modules/login/loginTypes"
import { CreateOrderDialogMode } from "../createOrderTypes"

export type OnBehalfCompletedDialog = {
    show: boolean
    userId: number
    displayName: string
    companyId: number
    userType: UserType
}

type useCreateOrderUserOptions = {
    mode?: CreateOrderDialogMode
}

export function useCreateOrderUser(opts?: useCreateOrderUserOptions) {
    const { mode = "create" } = opts ?? {}
    const user = useEffectiveUserSnapshot()

    const initialOnBehalf = useMemo<OnBehalfCompletedDialog>(
        () => ({
            show: !(user.userType === UserType.USER) && mode === "create",
            userId: user.userId,
            displayName: user.displayName,
            companyId: user.companyId,
            userType: user.userType,
        }),
        [user.userType, user.userId, user.displayName, user.companyId, mode],
    )

    const [onBehalf, setOnBehalf] = useState<OnBehalfCompletedDialog>(initialOnBehalf)

    useEffect(() => {
        if (!user.displayName) return
        setOnBehalf((prev) =>
            prev.displayName === user.displayName ? prev : { ...prev, displayName: user.displayName },
        )
    }, [user.displayName])

    return {
        onBehalf,
        setOnBehalf,
    }
}
